import React from "react";
import { I18n } from "@aws-amplify/core";
import moment from "moment-timezone";
import { toUpper, get } from "lodash";

const defaultFormat = "MM/DD/YYYY[,] hh:mm:ss A";
const databaseFormat = "YYYY-MM-DD[T]HH:mm:ss[Z]";

export const formatDate = (date, format) => {
  let dateFormat = format || defaultFormat;
  let userTimezone = moment.tz.guess();
  moment.tz.setDefault("Etc/UTC");
  return moment(date).tz(userTimezone).format(dateFormat);
};

export const toTimeZone = (date) => {
  let userTimezone = moment.tz.guess();
  moment.tz.setDefault("Etc/UTC");
  return moment(date).tz(userTimezone);
};

// Change date to UTC and database format
export const dbFormat = (date, format = databaseFormat) => {
  let userTimezone = moment.tz.guess();
  moment.tz.setDefault("Etc/UTC");
  let utcDate = moment.tz(date, userTimezone).clone().tz("Etc/UTC");
  return moment(utcDate).format(format);
};

export const toUTCTimestamp = (date) => {
  let userTimezone = moment.tz.guess();
  moment.tz.setDefault("Etc/UTC");
  return moment(date).tz(userTimezone).valueOf();
};

export const formatChrono = (date, format) => {
  let dateFormat = format || defaultFormat;
  moment.tz.setDefault("Etc/UTC");
  return moment(date).format(dateFormat);
};

export const nowWithOutSeconds = () => {
  let res = new Date();
  res.setSeconds(0);
  res.setMilliseconds(0);
  return res.getTime();
};

export const setToMidnight = (date) => {
  let res = new Date(date);
  res.setHours(0);
  res.setMinutes(0);
  res.setSeconds(0);
  res.setMilliseconds(0);
  return res.getTime();
};

/**
 * input: duration in seconds
 * output:
 *    if duration < 1h --> 1m 30s
 *    else if duration < 1day --> 4h 25m
 *    else --> 4 days 2h
 */
export const formatDuration = (duration) => {
  if (!duration) {
    return <span className="text-87">-</span>;
  }
  if (duration < 3600) {
    return formatDate(duration * 1000, "m[m] ss[s]");
  }
  if (duration < 86400) {
    return formatDate(duration * 1000, "H[h] mm[m]");
  }
  return `
  ${formatDate(
    (duration - 86400) * 1000,
    `D [${I18n.get(duration < 172800 ? "dashboard_day" : "dashboard_days")}]`
  )} ${formatDate(duration * 1000, `H[h]`)}
  `;
};

export const formatTimeSlot = (start, end) => {
  return toUpper(
    `${hourToAmPm(
      get(start, ["hours"]),
      get(start, ["minutes"])
    )} - ${hourToAmPm(get(end, ["hours"]), get(end, ["minutes"]))}`
  );
};

export const computePeriod = (periodLength) => {
  const now = new Date();
  const midnight = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0
  );
  const startDate =
    periodLength === "0"
      ? midnight.getTime()
      : new Date(midnight - 86400000 * periodLength).getTime();
  const endDate =
    periodLength === "0" ? midnight.getTime() + 86400000 : midnight.getTime();
  return [startDate, endDate];
};

export const isToday = (date) => {
  const now = new Date();
  if (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  ) {
    return true;
  }
  return false;
};

export const hourToAmPm = (hour, minute) => {
  hour = hour % 24;
  if (hour < 12) {
    return `${hour === 0 ? 12 : hour}${minute ? `:${minute}` : ""} am`;
  }
  return `${hour === 12 ? 12 : hour - 12}${minute ? `:${minute}` : ""} pm`;
};

export const formatDateLabel = (date) => {
  return `${formatDate(date, "DD/MM/YYYY")}`;
};
